import styled from 'styled-components';

export const CardSubTaskListContainer = styled.div`
  border-top: 1px solid var(--gray-20);
  padding: var(--spacing-03) 0px;
`;
export const CardSubTaskList = styled.div`
  display: flex;
  align-items: center;
  padding: 0px var(--spacing-03);

  &:hover {
    background-color: var(--ozone-cool-gray-surface);
  }
`;
